<button *ngIf="buttonTag"  type="button" class="btn btn-secondary download_button" (click)="downloadAttachedFile()">{{buttonText}}</button>
<a style="color: #ef7e22" *ngIf="!buttonTag" (click)="downloadAttachedFile()" [ngStyle]="{'pointer-events':FileinputDisabled === true ? 'none' : 'auto' }">{{buttonText}}</a>
